import Block from '../block'

export default class Color extends Block {
	static title = 'color'

	init() {
		this.inputElement = this.getElement('input')
		if (this.inputElement) {
			this.inputElement.addEventListener('change', e => this.handleChange(e))
		}
	}

	handleChange(e) {
		this.eventEmitter.emit('color:change', {
			colorId: e.target.value,
			colorName: this.element.getAttribute('data-title'),
			productId: this.element.getAttribute('data-product-id'),
		})
	}

	show() {
		this.removeModifier('hidden')
	}

	hide() {
		this.addModifier('hidden')
		this.element.checked = false
	}
}
